import { HasValue, validator } from '@ally/validator';
export var HasValueErrorMessage = 'Please select a date.';
export var HasValueValidator = validator(HasValue, HasValueErrorMessage);
//# sourceMappingURL=HasValue.js.map